import { Injectable, Inject } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/Rx';  // use this line if you want to be lazy, otherwise:
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';  // debug
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { HandleError, HttpErrorHandler } from 'mds-ui/app/shared/service/http-error-handler.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PersonInfo, PriestsearchVO, PersonAssociationTypeVO, PersonInfoResponse, PersonInfoSearchVO, ConsecratedPersonDetails } from '../../../users/admin-profile/models/personinfo';
import { environment } from 'mds-ui/environments/environment';
import { Observable } from 'rxjs/Rx';
import { catchError } from 'rxjs/operators';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';
import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';
import { SearchVO } from 'mds-ui/app/shared/model/consecratedPerson';


@Injectable()
export class PersonInfoService {
    public ordainedSeminarians: boolean;
    public personInfo: PersonInfo;
    public consecratedPersonDetails: ConsecratedPersonDetails;
    public personAssociationTypeVO: PersonAssociationTypeVO;
    private handleError: HandleError;
    dtformat = new DateTimeFormatPipe("en-US");
    public personInfoSearchVO: SearchVO;
    prefix: string;
    suffix: string;
    phoneChange ='+919985174000';
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {

        this.handleError = httpErrorHandler.createHandleError('PersonInfoService');
    }

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };
    personInfoInit() {
        this.personInfo = new PersonInfo();

    }
    personAssociateTypeInit() {
        this.personAssociationTypeVO = new PersonAssociationTypeVO();

    }

    getPersonInfoList(): Observable<PersonInfo[]> {
        return this._http.get<PersonInfo[]>(

            environment.personInfoURL, this.httpOptions)
            .pipe(
                catchError(this.handleError('getPersonInfoList', []))
            );
    }

    getPersonInfoById(id: number): Observable<PersonInfo[]> {
        return this._http.get<PersonInfo[]>(
            environment.personinfoByIdUrl + id, this.httpOptions)
            .pipe(
                catchError(this.handleError('getPersonInfoById', []))
            );

    }
    personInfoSave(personInfo: PersonInfo): Observable<PersonInfo[]> {
        return this._http.post<PersonInfo[]>(environment.postPersonInfoURL, personInfo, this.httpOptions).pipe(
            catchError(this.handleError('personInfoSave()', [])));
    }
    getTabsByType(type: string): Observable<any> {
        return this._http.get<any>(
            environment.tabsByTypeUrl + type, this.httpOptions)
            .pipe(
                catchError(this.handleError('getTabsByType', []))
            );

    }
    personSearch(personInfo: PriestsearchVO): Observable<PersonInfo[]> {
        return this._http.post<PersonInfo[]>(environment.postPersonSearchURL, personInfo, this.httpOptions).pipe(
            catchError(this.handleError('personSearch()', [])));
    }

    getPersonInfoDetailsCount(personInfoSearchVO: PersonInfoSearchVO, appName: string, userEmailId: string): Observable<number> {
        return this._http.post<any>(
            environment.getPersonInfoDetailsCountUrl + "?appName=" + appName + "&userEmailId=" + userEmailId, personInfoSearchVO, this.httpOptions)
            .pipe(
                catchError(this.handleError('getPersonInfoDetailsCount', []))
            );
    }

    getAllPersonInfo(personInfoSearchVO: PersonInfoSearchVO, appName: string, userEmailId: string): Observable<PersonInfoResponse[]> {
        return this._http.post<PersonInfoResponse[]>(
            environment.getAllPersonInfoUrl + "?appName=" + appName + "&userEmailId=" + userEmailId, personInfoSearchVO, this.httpOptions)
            .pipe(catchError(this.handleError('getPersonInfoDetails', [])));
    }


    isConsecratedPerson(email: string): Observable<any> {
        return this._http.get<any>(
            environment.isConsecratedPersonURL + email, this.httpOptions)
            .pipe(
                catchError(this.handleError('isConsecratedPerson', []))
            );

    }
    getPersonInfoByMail(mail: string): Observable<PersonInfo[]> {
        return this._http.get<PersonInfo[]>(
            environment.personinfoByMailUrl + mail, this.httpOptions)
            .pipe(
                catchError(this.handleError('getPersonInfoById', []))
            );

    }


    getPrefixSuffixDetailsByType(typename: string, username: string, associateName: string): Observable<any> {
        return this._http.get<any>(
            environment.getPrefixSuffixDetailsByTypeUrl + typename + "/associate"
            + "?associate-name=" + associateName + "&username=" + username, this.httpOptions)
            .pipe(
                catchError(this.handleError('getPrefixSuffixDetailsByType', []))
            );
    }

    getEmailHistoryById(id: number, userName: string): Observable<any> {
        return this._http.get<any>(
            environment.emailHistoryByIdUrl + "?id=" + id + "&userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getEmailHistoryById', []))
            );

    }

    getPhoneHistoryById(id: number, userName: string): Observable<any> {
        return this._http.get<any>(
            environment.phonelHistoryByIdUrl + "?id=" + id + "&userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getPhoneHistoryById', []))
            );

    }

    isLoginIdExist(loginId: string): Observable<number> {
        return this._http.get<any>(
            environment.isLoginIdExistUrl + loginId, this.httpOptions)
            .pipe(
                catchError(this.handleError('isLoginIdExist', []))
            );
    }

    deletePersonInfo(personId: number,appName: string,username: string): Observable<ApiResponse> {
        return this._http.get<any>(environment.deletepersonInfoUrl+ personId+"/application/"+appName+"?username="+username, this.httpOptions)
            .pipe(catchError(this.handleError('deletePersonInfo', [])));
    }

    postImage(id: number, image:File, userName: string): Observable<ApiResponse> {
        const formData: FormData = new FormData(); 
            const file: File = image;
            formData.append(`image`,file,file.name); 
        let options = {
            headers: new HttpHeaders({
                'enctype': 'multipart/form-data', 
                "Cache-Control": "no-cache",
                Pragma: "no-cache"
            })
        }; 
        return this._http.post<any>(
            environment.postImageUrl +"?id=" + id + "&userName=" + userName, formData, options)
            .pipe(
                catchError(this.handleError('postImage', []))
            );
    }

}